const ESP_NAMESPACE = 'jbp-esp'

/**
 * Translation keys for the ESP pilot. The strings themselves live in the backend
 * translation service; until they are registered there, the raw keys render on screen.
 * The full list is documented in the feature README.
 */
export const ESP_TRANSLATION_KEYS = {
  status: {
    notOnboarded: `${ESP_NAMESPACE}--status--not-onboarded`,
    pending: `${ESP_NAMESPACE}--status--pending`,
    active: `${ESP_NAMESPACE}--status--active`,
  },
  requestForm: {
    enrollTitle: `${ESP_NAMESPACE}--request-form--enroll-title`,
    changeTitle: `${ESP_NAMESPACE}--request-form--change-title`,
    sponsorLabel: `${ESP_NAMESPACE}--request-form--sponsor-label`,
    sponsorEmailLabel: `${ESP_NAMESPACE}--request-form--sponsor-email-label`,
    accountSectionTitle: `${ESP_NAMESPACE}--request-form--account-section-title`,
    accountSectionHint: `${ESP_NAMESPACE}--request-form--account-section-hint`,
    additionalSectionTitle: `${ESP_NAMESPACE}--request-form--additional-section-title`,
    partnerName: `${ESP_NAMESPACE}--request-form--partner-name`,
    partnerId: `${ESP_NAMESPACE}--request-form--partner-id`,
    partnerCountry: `${ESP_NAMESPACE}--request-form--partner-country`,
    accountClassification: `${ESP_NAMESPACE}--request-form--account-classification`,
    accountSegment: `${ESP_NAMESPACE}--request-form--account-segment`,
    employeesCount: `${ESP_NAMESPACE}--request-form--employees-count`,
    annualRevenue: `${ESP_NAMESPACE}--request-form--annual-revenue`,
    accountValue: `${ESP_NAMESPACE}--request-form--account-value`,
    isBusinessGrowing: `${ESP_NAMESPACE}--request-form--is-business-growing`,
    accountContact: `${ESP_NAMESPACE}--request-form--account-contact`,
    missionAndVision: `${ESP_NAMESPACE}--request-form--mission-and-vision`,
    keyChallenges: `${ESP_NAMESPACE}--request-form--key-challenges`,
    productsAndSolutions: `${ESP_NAMESPACE}--request-form--products-and-solutions`,
    justification: `${ESP_NAMESPACE}--request-form--justification`,
    cancel: `${ESP_NAMESPACE}--request-form--cancel`,
    submit: `${ESP_NAMESPACE}--request-form--submit`,
  },
  admin: {
    pageTitle: `${ESP_NAMESPACE}--admin--page-title`,
    tableTitle: `${ESP_NAMESPACE}--admin--table-title`,
    emptyFiltered: `${ESP_NAMESPACE}--admin--empty-filtered`,
    columnPartner: `${ESP_NAMESPACE}--admin--column-partner`,
    columnType: `${ESP_NAMESPACE}--admin--column-type`,
    columnSponsor: `${ESP_NAMESPACE}--admin--column-sponsor`,
    columnRequestedBy: `${ESP_NAMESPACE}--admin--column-requested-by`,
    columnSubmitted: `${ESP_NAMESPACE}--admin--column-submitted`,
    columnStatus: `${ESP_NAMESPACE}--admin--column-status`,
    detailTitle: `${ESP_NAMESPACE}--admin--detail-title`,
    openPartnerPage: `${ESP_NAMESPACE}--admin--open-partner-page`,
    detailRequestedBy: `${ESP_NAMESPACE}--admin--detail-requested-by`,
    detailEmpty: `${ESP_NAMESPACE}--admin--detail-empty`,
    rejectionReason: `${ESP_NAMESPACE}--admin--rejection-reason`,
    typeEnrollment: `${ESP_NAMESPACE}--admin--type-enrollment`,
    typeChange: `${ESP_NAMESPACE}--admin--type-change`,
    statusPending: `${ESP_NAMESPACE}--admin--status-pending`,
    statusApproved: `${ESP_NAMESPACE}--admin--status-approved`,
    statusRejected: `${ESP_NAMESPACE}--admin--status-rejected`,
    actionApprove: `${ESP_NAMESPACE}--admin--action-approve`,
    actionReject: `${ESP_NAMESPACE}--admin--action-reject`,
    actionDelete: `${ESP_NAMESPACE}--admin--action-delete`,
    empty: `${ESP_NAMESPACE}--admin--empty`,
    approveConfirmTitle: `${ESP_NAMESPACE}--admin--approve-confirm-title`,
    approveConfirmMessage: `${ESP_NAMESPACE}--admin--approve-confirm-message`,
    approveConfirmBtn: `${ESP_NAMESPACE}--admin--approve-confirm-btn`,
    deleteConfirmTitle: `${ESP_NAMESPACE}--admin--delete-confirm-title`,
    deleteConfirmMessage: `${ESP_NAMESPACE}--admin--delete-confirm-message`,
    deleteConfirmBtn: `${ESP_NAMESPACE}--admin--delete-confirm-btn`,
    confirmCancelBtn: `${ESP_NAMESPACE}--admin--confirm-cancel-btn`,
    rejectDialogTitle: `${ESP_NAMESPACE}--admin--reject-dialog-title`,
    rejectReasonLabel: `${ESP_NAMESPACE}--admin--reject-reason-label`,
    rejectSubmit: `${ESP_NAMESPACE}--admin--reject-submit`,
    rejectCancel: `${ESP_NAMESPACE}--admin--reject-cancel`,
  },
  // The sponsor directory on the Approval Dashboard. Available params: {active}, {shown}, {total}.
  sponsors: {
    pageCaption: `${ESP_NAMESPACE}--sponsors--page-caption`,
    pageTitle: `${ESP_NAMESPACE}--sponsors--page-title`,
    title: `${ESP_NAMESPACE}--sponsors--title`,
    countActive: `${ESP_NAMESPACE}--sponsors--count-active`,
    countShown: `${ESP_NAMESPACE}--sponsors--count-shown`,
    search: `${ESP_NAMESPACE}--sponsors--search`,
    add: `${ESP_NAMESPACE}--sponsors--add`,
    edit: `${ESP_NAMESPACE}--sponsors--edit`,
    columnName: `${ESP_NAMESPACE}--sponsors--column-name`,
    columnTitle: `${ESP_NAMESPACE}--sponsors--column-title`,
    columnLevel: `${ESP_NAMESPACE}--sponsors--column-level`,
    columnRegion: `${ESP_NAMESPACE}--sponsors--column-region`,
    empty: `${ESP_NAMESPACE}--sponsors--empty`,
    emptySearch: `${ESP_NAMESPACE}--sponsors--empty-search`,
    dialogAddTitle: `${ESP_NAMESPACE}--sponsors--dialog-add-title`,
    dialogEditTitle: `${ESP_NAMESPACE}--sponsors--dialog-edit-title`,
    fieldName: `${ESP_NAMESPACE}--sponsors--field-name`,
    fieldTitle: `${ESP_NAMESPACE}--sponsors--field-title`,
    fieldLevel: `${ESP_NAMESPACE}--sponsors--field-level`,
    fieldRegion: `${ESP_NAMESPACE}--sponsors--field-region`,
    fieldActive: `${ESP_NAMESPACE}--sponsors--field-active`,
    activeHint: `${ESP_NAMESPACE}--sponsors--active-hint`,
    cancel: `${ESP_NAMESPACE}--sponsors--cancel`,
    save: `${ESP_NAMESPACE}--sponsors--save`,
  },
  activities: {
    modalTitle: `${ESP_NAMESPACE}--activities--modal-title`,
    addActivity: `${ESP_NAMESPACE}--activities--add-activity`,
    empty: `${ESP_NAMESPACE}--activities--empty`,
    bannerActive: `${ESP_NAMESPACE}--activities--banner-active`,
    bannerSponsor: `${ESP_NAMESPACE}--activities--banner-sponsor`,
    bannerSince: `${ESP_NAMESPACE}--activities--banner-since`,
    bannerChangeSponsor: `${ESP_NAMESPACE}--activities--banner-change-sponsor`,
    logTitle: `${ESP_NAMESPACE}--activities--log-title`,
    logCount: `${ESP_NAMESPACE}--activities--log-count`,
    entryWith: `${ESP_NAMESPACE}--activities--entry-with`,
    // Available params: {outcome}.
    entryOutcome: `${ESP_NAMESPACE}--activities--entry-outcome`,
    actionEdit: `${ESP_NAMESPACE}--activities--action-edit`,
    actionDelete: `${ESP_NAMESPACE}--activities--action-delete`,
    deleteConfirmTitle: `${ESP_NAMESPACE}--activities--delete-confirm-title`,
    deleteConfirmMessage: `${ESP_NAMESPACE}--activities--delete-confirm-message`,
    deleteConfirmBtn: `${ESP_NAMESPACE}--activities--delete-confirm-btn`,
    confirmCancelBtn: `${ESP_NAMESPACE}--activities--confirm-cancel-btn`,
    formAddTitle: `${ESP_NAMESPACE}--activities--form-add-title`,
    formEditTitle: `${ESP_NAMESPACE}--activities--form-edit-title`,
    dateLabel: `${ESP_NAMESPACE}--activities--date-label`,
    // The date falls in a quarter that already has an engagement. Available params: {quarter}.
    quarterTaken: `${ESP_NAMESPACE}--activities--quarter-taken`,
    typeLabel: `${ESP_NAMESPACE}--activities--type-label`,
    meetingReasonLabel: `${ESP_NAMESPACE}--activities--meeting-reason-label`,
    outcomeLabel: `${ESP_NAMESPACE}--activities--outcome-label`,
    attendeesLabel: `${ESP_NAMESPACE}--activities--attendees-label`,
    topicsLabel: `${ESP_NAMESPACE}--activities--topics-label`,
    notesLabel: `${ESP_NAMESPACE}--activities--notes-label`,
    notesHintBefore: `${ESP_NAMESPACE}--activities--notes-hint-before`,
    notesHintLink: `${ESP_NAMESPACE}--activities--notes-hint-link`,
    notesHintAfter: `${ESP_NAMESPACE}--activities--notes-hint-after`,
    // Available params: {managers}.
    managersCopy: `${ESP_NAMESPACE}--activities--managers-copy`,
    cancel: `${ESP_NAMESPACE}--activities--cancel`,
    saveActivity: `${ESP_NAMESPACE}--activities--save-activity`,
  },
  dashboard: {
    title: `${ESP_NAMESPACE}--dashboard--title`,
    subtitle: `${ESP_NAMESPACE}--dashboard--subtitle`,
    viewLabel: `${ESP_NAMESPACE}--dashboard--view-label`,
    viewAllPartners: `${ESP_NAMESPACE}--dashboard--view-all-partners`,
    sponsorFilter: `${ESP_NAMESPACE}--dashboard--sponsor-filter`,
    sponsorFilterAll: `${ESP_NAMESPACE}--dashboard--sponsor-filter-all`,
    cardPartnersWithActivity: `${ESP_NAMESPACE}--dashboard--card-partners-with-activity`,
    cardCoverage: `${ESP_NAMESPACE}--dashboard--card-coverage`,
    cardActivitiesLogged: `${ESP_NAMESPACE}--dashboard--card-activities-logged`,
    cardPartnersWithoutActivity: `${ESP_NAMESPACE}--dashboard--card-partners-without-activity`,
    byTypeTitle: `${ESP_NAMESPACE}--dashboard--by-type-title`,
    bySponsorTitle: `${ESP_NAMESPACE}--dashboard--by-sponsor-title`,
    columnSponsor: `${ESP_NAMESPACE}--dashboard--column-sponsor`,
    columnPartners: `${ESP_NAMESPACE}--dashboard--column-partners`,
    columnCoverage: `${ESP_NAMESPACE}--dashboard--column-coverage`,
    columnLastEngagement: `${ESP_NAMESPACE}--dashboard--column-last-engagement`,
    attentionTitle: `${ESP_NAMESPACE}--dashboard--attention-title`,
    attentionHint: `${ESP_NAMESPACE}--dashboard--attention-hint`,
    columnPartner: `${ESP_NAMESPACE}--dashboard--column-partner`,
    columnLastActivity: `${ESP_NAMESPACE}--dashboard--column-last-activity`,
    columnActivities: `${ESP_NAMESPACE}--dashboard--column-activities`,
    noneLogged: `${ESP_NAMESPACE}--dashboard--none-logged`,
    empty: `${ESP_NAMESPACE}--dashboard--empty`,
    attentionEmpty: `${ESP_NAMESPACE}--dashboard--attention-empty`,
    sponsorsEmpty: `${ESP_NAMESPACE}--dashboard--sponsors-empty`,
  },
}
